<template>
  <div>
    <b-row>
      <b-col cols="12" md="12" lg="12">
        <b-table :items="kebutuhanPelamar" :fields="fields" responsive small bordered striped hover>
          <template #cell(file1)="item">
            <b-button variant="primary" class="mr-1" @click="selectFile(item.index), (kebutuhanPelamarId = item.item.kebutuhanPelamarId)">{{ $store.state.form.uploadFile }}</b-button>
            <b-button style="margin-left: 10px" v-if="item.item.statusKebutuhan != 0" variant="dark" @click="view(item.item.fileKebutuhan)">{{ $store.state.form.lihatFile }}</b-button>
          </template>
          <template #cell(statusKebutuhan)="item">
            <b-form-checkbox v-model="item.item.statusKebutuhan" disabled value="1" unchecked-value="0"> </b-form-checkbox>
          </template>
        </b-table>
        <div class="input-files">
          <input class="inputan" type="file" id="file1" ref="file1" @input="handleFile()" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "inputTabProfil",
  props: ["kebutuhanPelamar", "data"],
  data() {
    return {
      // data: {
      //   pasFoto4x6: 0,
      // },
      indexUpload: "",
      kebutuhanPelamarId: "",
      postLokerId: "",
      file1: "",
      loading: false,
      fields: [
        {
          key: "namaKebutuhan",
          label: "Nama Lampiran",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "file1",
          label: "Upload File",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "statusKebutuhan",
          label: "Checklist",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
      ],
    };
  },
  methods: {
    handleFile() {
      let vm = this;
      vm.file1 = vm.$refs.file1.files[0];
      vm.kirimFile(vm.indexUpload);
    },
    selectFile(y) {
      let fileInputElement = this.$refs.file1;
      fileInputElement.click();
      this.indexUpload = y;
    },
    view(x) {
      let kode = this.$store.state.kode_client ? this.$store.state.kode_client : null;
      let ip = `https://${kode}.storage.googleapis.com/`;
      window.open(ip + x);
    },
    kirimFile(y) {
      let vm = this;
      let formData = new FormData();
      formData.append("kebutuhanPelamarId", vm.kebutuhanPelamarId);
      formData.append("file1", vm.file1);
      vm.$axios
        .post("kelengkapanLamaran/updateFile", formData)
        .then((res) => {
          console.log(res);
          if (res.data.message == "sukses") {
            vm.loading = false;
            vm.kebutuhanPelamar[y].statusKebutuhan = 1;
            vm.kebutuhanPelamar[y].file1 = res.data.data;
          } else {
            vm.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.inputan {
  visibility: hidden;
}
</style>
